import VueTagManager from '@discoveryeducation/components/src/GoogleTagManager';
import { APP_GTM_ENABLED, APP_GTM_ID } from '../environment';

const optionsTagManager = {
  id: APP_GTM_ID,
  enabled: APP_GTM_ENABLED,
};

export { VueTagManager, optionsTagManager };
